import { render, staticRenderFns } from "./CabecalhoPagina.vue?vue&type=template&id=75071e7e&scoped=true"
import script from "./CabecalhoPagina.vue?vue&type=script&lang=js"
export * from "./CabecalhoPagina.vue?vue&type=script&lang=js"
import style0 from "./CabecalhoPagina.vue?vue&type=style&index=0&id=75071e7e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75071e7e",
  null
  
)

export default component.exports